import React from 'react'
import { useHistory } from 'react-router-dom'
import { Step, SingleAnswer } from '../../components'
import { useOnboarding } from '../../context'

const AGES = {
  key: 'is_minor',
  trackingKey: 'age',
  question: 'Please tell us your age',
  choices: [
    { text: 'I’m 18+', value: false },
    { text: 'I’m under 18', value: true }
  ]
}

export const StudentAge = ({ index }) => {
  const history = useHistory()
  const { updateProperties, postSurvey } = useOnboarding()

  React.useEffect(() => {
    postSurvey().catch(console.error)
  }, [])

  function handleChoice(isMinor) {
    updateProperties({ payload: { isMinor } }).catch(console.error)
    if (isMinor) return
    history.push('/onboarding/upsell')
  }

  return (
    <Step
      index={index}
      trackingKey={AGES.trackingKey}
      itemsCount={AGES.choices.length}
      title={AGES.question}
      subtitle='Select one (Required)'
    >
      {AGES.choices.map(({ text, value }) => {
        const isMinor = !!value

        return (
          <SingleAnswer
            key={`${text}-${value}`}
            question={AGES.question}
            surveyKey={AGES.key}
            text={text}
            icon={null}
            value={value}
            onClick={() => handleChoice(value)}
            disableAutoNext={!isMinor}
          />
        )
      })}
    </Step>
  )
}
